@if (transaction(); as transaction) {
  <div class="bg-[#022D35] rounded-[6px] px-3 py-4">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <div class="flex items-center">
          <mat-icon svgIcon="clock-two" class="text-[#9EA2A6] !w-[18px] !h-[18px] mr-2"></mat-icon>
          <span class="text-[14px] text-white">
            Incident Progress
          </span>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form" class="flex flex-col">
        <div class="flex gap-2">
          @let stepOneCurrent = transaction.nextIncidentProgressStep === 'CASE_REPORTED';
          @let stepOneSuccess = ['AWAITING_LEA_SUBMISSION', 'CASE_CLOSED', 'PERMANENT_FREEZE', 'RECOVERY_OF_FUNDS', 'TEMPORARY_FREEZE'].includes(transaction.nextIncidentProgressStep);
          <div class="flex relative">
            @if (stepOneCurrent) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-current"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepOneSuccess) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-success"></mat-icon>
              <span class="incident-line-success"></span>
            }
          </div>
          <div class="flex flex-col w-full pb-[34px]">
            <div class="flex items-center justify-between mb-3">
              <h4 class="font-bold text-[14px] leading-[1.2] text-white">Criminal Case Reported</h4>
              @if (stepOneSuccess) {
                <span class="text-white/50 text-[14px]">{{ transaction.timeCreated | date: 'dd.MM.yyyy | HH:mm' }}</span>
              }
            </div>
            <ul class="pl-5">
              <li class="text-[12px] text-white/70 list-disc">Internal compliance window: 48 hours to initiate coordination with law enforcement authorities (LEA)</li>
            </ul>
          </div>
        </div>
        <div class="flex gap-2">
          @let stepTwoCurrent = transaction.nextIncidentProgressStep === 'TEMPORARY_FREEZE';
          @let stepTwoSuccess = ['AWAITING_LEA_SUBMISSION', 'CASE_CLOSED', 'PERMANENT_FREEZE', 'RECOVERY_OF_FUNDS'].includes(transaction.nextIncidentProgressStep);
          @let stepTwoNext = ['CASE_REPORTED'].includes(transaction.nextIncidentProgressStep);
          <div class="flex relative">
            @if (stepTwoCurrent) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-current"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepTwoSuccess) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-success"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepTwoNext) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-next"></mat-icon>
              <span class="incident-line-next"></span>
            }
          </div>
          <div class="flex flex-col w-full pb-[34px]">
            <div class="flex items-center justify-between gap-2 mb-3">
              <h4 class="font-bold text-[14px] leading-[1.2] text-white"
                [ngClass]="{
                  'text-[24px] -mt-2': stepTwoCurrent
                }"
              >Temporary Asset Freeze</h4>
              @if (stepTwoSuccess) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">{{ transaction.incidentProgressMap.TEMPORARY_FREEZE.createdAt | date: 'dd.MM.yyyy | HH:mm' }}</span>
              }
            </div>
            @if (stepTwoCurrent) {
              @let temporaryDateControl = form.controls['temporaryDate'];
              @let temporaryTimeControl = form.controls['temporaryTime'];
              @let datePickerControlInvalid = (temporaryDateControl.invalid && temporaryDateControl.touched) || (temporaryTimeControl.invalid && temporaryTimeControl.touched);
              @if (isComplianceRole()) {
                <div [ngClass]="{
                  '!border-[#C93535]': datePickerControlInvalid,
                  'bg-[#C93535]/30': datePickerControlInvalid
                }"
                  class="datepicker-wrap mb-3 border border-solid h-[54px] border-[#D8E1E1] px-[8px] py-[3px] flex items-center w-full gap-2 rounded-[6px] relative focus-within:border-[#D8E1E1]">
                  <div class="flex flex-col gap-1 w-full pb-[2px] h-full overflow-hidden">
                    <div class="flex items-center text-[12px] gap-[8px] leading-[1] mb-[5px] font-base whitespace-nowrap">
                      <label class="text-white/70">Temporary Freeze Duration:</label>
                    </div>
                    <div class="flex items-center">
                      <input formControlName="temporaryDate" [readonly]="true" [min]="limitedMinDate" class="outline-none cursor-pointer !leading-[1.25] text-[14px] bg-transparent text-white placeholder:text-[#FB0] w-[90px]" placeholder="Choose date" matInput [matDatepicker]="datePickerTemporary" (click)="datePickerTemporary.open()"
                        [ngClass]="{'placeholder:!text-[#C93535]': datePickerControlInvalid}"
                      >
                      <span class="text-[14px] text-[#FB0] leading-[1]" [ngClass]="{
                        '!text-white': form.controls['temporaryDate'].valid && form.controls['temporaryTime'].valid,
                        '!text-[#C93535]': datePickerControlInvalid
                        }">|</span>
                      <input formControlName="temporaryTime" [readonly]="true" [matTimepickerMin]="limitedTemporaryMinTime" class="outline-none cursor-pointer !leading-[1.25] text-[14px] bg-transparent text-white placeholder:text-[#FB0] w-[90px] ml-2" placeholder="Choose time" matInput [matTimepicker]="timePickerTemporary"
                      [ngClass]="{
                        'placeholder:!text-[#C93535]': datePickerControlInvalid,
                        'pointer-events-none': temporaryDateControl.invalid
                        }">
                    </div>
                      <mat-datepicker-toggle class="absolute right-0 top-1/2 -translate-y-1/2 icon-yellow" [ngClass]="{'!text-[#C93535]': datePickerControlInvalid}" matIconSuffix [for]="datePickerTemporary"></mat-datepicker-toggle>
                      <mat-datepicker #datePickerTemporary (closed)="handleClosedDatePickerTemporary(timePickerTemporary, 'temporary')"></mat-datepicker>
                      <mat-timepicker-toggle matIconSuffix [for]="timePickerTemporary"/>
                      <mat-timepicker #timePickerTemporary/>
                  </div>
                </div>
              }
              <ul class="pl-5">
                <li class="text-[12px] text-[#80969A]/70 list-disc">Applies in accordance with LEA directive under asset protection protocol</li>
              </ul>
            }
            @if (stepTwoSuccess) {
              <ul class="pl-5">
                <li class="text-[12px] text-white/70 list-disc">SLA met within ~48 hours <br> Implemented as part of initial response protocol to prevent asset flight prior to formal LEA action</li>
              </ul>
            }
          </div>
        </div>
        <div class="flex gap-2">
          @let stepThreeCurrent = transaction.nextIncidentProgressStep === 'AWAITING_LEA_SUBMISSION';
          @let stepThreeSuccess = ['CASE_CLOSED', 'PERMANENT_FREEZE', 'RECOVERY_OF_FUNDS'].includes(transaction.nextIncidentProgressStep);
          @let stepThreeNext = ['CASE_REPORTED', 'TEMPORARY_FREEZE'].includes(transaction.nextIncidentProgressStep);
          <div class="flex relative">
            @if (stepThreeCurrent) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-current"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepThreeSuccess) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-success"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepThreeNext) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-next"></mat-icon>
              <span class="incident-line-next"></span>
            }
          </div>
          <div class="flex flex-col w-full pb-[34px]">
            <div class="flex items-center justify-between gap-2 mb-3">
              <h4 class="font-bold text-[14px] leading-[1.2] text-white"
                [ngClass]="{
                  'text-[24px] -mt-2': stepThreeCurrent
                }"
                >Awaiting LEA Freeze <br> Request Submission</h4>
              @if (stepThreeSuccess) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">{{ transaction.incidentProgressMap.AWAITING_LEA_SUBMISSION.createdAt | date: 'dd.MM.yyyy | HH:mm' }}</span>
              }
              @if (stepThreeNext) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">~ 48 hours</span>
              }
            </div>
            @if (stepThreeCurrent) {
              <div class="flex flex-col">
                <span class="text-[12px] text-white/70 mb-1">Estimated Time Remaining for Freeze Request Submission:</span>
                <app-lea-timer [time]="transaction.incidentProgressMap?.TEMPORARY_FREEZE?.expiresIn ?? 0"></app-lea-timer>
              </div>
            }
            @if (stepThreeSuccess) {
              <ul class="pl-5">
                <li class="text-[12px] text-white/70 list-disc">Completed within the expected 48-hour window. <br> Monitoring phase — LEA informed and expected to initiate formal freeze request under applicable legal authority</li>
              </ul>
            }
            @if (stepThreeNext) {
              <ul class="pl-5">
                <li class="text-[12px] text-[#80969A]/70 list-disc">Coordination phase — monitoring deadline for law enforcement to submit formal asset freeze request</li>
              </ul>
            }
          </div>
        </div>
        <div class="flex gap-2">
          @let stepFourCurrent = transaction.nextIncidentProgressStep === 'PERMANENT_FREEZE';
          @let stepFourSuccess = ['CASE_CLOSED', 'RECOVERY_OF_FUNDS'].includes(transaction.nextIncidentProgressStep);
          @let stepFourNext = ['CASE_REPORTED', 'TEMPORARY_FREEZE', 'AWAITING_LEA_SUBMISSION'].includes(transaction.nextIncidentProgressStep);
          <div class="flex relative">
            @if (stepFourCurrent) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-current"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepFourSuccess) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-success"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepFourNext) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-next"></mat-icon>
              <span class="incident-line-next"></span>
            }
          </div>
          <div class="flex flex-col w-full pb-[34px]">
            <div class="flex items-center justify-between gap-2 mb-3">
              <h4 class="font-bold text-[14px] leading-[1.2] text-white"
                [ngClass]="{
                  'text-[24px] -mt-2': stepFourCurrent
                }"
                >Permanent Freeze <br> Enforced by LEA Request</h4>
              @if (stepFourSuccess) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">{{ transaction.incidentProgressMap.PERMANENT_FREEZE.createdAt | date: 'dd.MM.yyyy | HH:mm' }}</span>
              }
              @if (stepFourNext) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">~ 10 hours</span>
              }
            </div>
            @if (stepFourCurrent) {
              <div class="flex flex-col mb-3">
                <span class="text-white text-[12px] leading-[1] mb-1">Comment:</span>
                <span class="text-[#B3C0C2] text-[12px] leading-[1] mb-1">{{transaction.incidentProgressMap?.AWAITING_LEA_SUBMISSION?.comment}}</span>
              </div>
              <div class="flex flex-col mb-3">
                <span class="text-[12px] text-white/70 mb-1">Temporary Freeze Expires in:</span>
                  <app-lea-timer [time]="transaction.incidentProgressMap?.TEMPORARY_FREEZE?.expiresIn ?? 0"></app-lea-timer>
              </div>
              @let permanentDateControl = form.controls['permanentDate'];
              @let permantnTimeControl = form.controls['permanentTime'];
              @let datePickerControlInvalid = (permanentDateControl.invalid && permanentDateControl.touched) || (permantnTimeControl.invalid && permantnTimeControl.touched);
              @if (isComplianceRole()) {
                <div [ngClass]="{
                  '!border-[#C93535]': datePickerControlInvalid,
                  'bg-[#C93535]/30': datePickerControlInvalid
                }"
                  class="datepicker-wrap mb-3 border border-solid h-[54px] border-[#D8E1E1] px-[8px] py-[3px] flex items-center w-full gap-2 rounded-[6px] relative focus-within:border-[#D8E1E1]">
                  <div class="flex flex-col gap-1 w-full pb-[2px] h-full overflow-hidden">
                    <div class="flex items-center text-[12px] gap-[8px] leading-[1] mb-[5px] font-base whitespace-nowrap">
                      <label class="text-white/70">Permanent Freeze Duration:</label>
                    </div>
                    <div class="flex items-center">
                      <input formControlName="permanentDate"  [readonly]="true" [min]="limitedMinDate" class="outline-none cursor-pointer !leading-[1.25] text-[14px] bg-transparent text-white placeholder:text-[#FB0] w-[90px]" placeholder="Choose date" matInput [matDatepicker]="datePickerPermanent" (click)="datePickerPermanent.open()"
                      [ngClass]="{'placeholder:!text-[#C93535]': datePickerControlInvalid}">
                      <span class="text-[14px] text-[#FB0] leading-[1]" [ngClass]="{
                        '!text-white': form.controls['permanentDate'].valid && form.controls['permanentTime'].valid,
                        '!text-[#C93535]': datePickerControlInvalid
                        }">|</span>
                      <input formControlName="permanentTime"  [readonly]="true" [matTimepickerMin]="limitedPermanentMinTime" class="outline-none cursor-pointer !leading-[1.25] text-[14px] bg-transparent text-white placeholder:text-[#FB0] w-[90px] ml-2" placeholder="Choose time" matInput [matTimepicker]="timePickerPermanent"
                      [ngClass]="{
                        'placeholder:!text-[#C93535]': datePickerControlInvalid,
                        'pointer-events-none': permanentDateControl.invalid
                      }">
                    </div>
                      <mat-datepicker-toggle class="absolute right-0 top-1/2 -translate-y-1/2 icon-yellow" [ngClass]="{'!text-[#C93535]': datePickerControlInvalid}" matIconSuffix [for]="datePickerPermanent"></mat-datepicker-toggle>
                      <mat-datepicker #datePickerPermanent (closed)="handleClosedDatePickerTemporary(timePickerPermanent, 'permanent')"></mat-datepicker>
                      <mat-timepicker-toggle matIconSuffix [for]="timePickerPermanent"/>
                      <mat-timepicker #timePickerPermanent/>
                  </div>
                </div>
              }
            }
            @if (stepFourSuccess) {
              <ul class="flex flex-col pl-5 gap-3">
                <li class="text-[12px] text-white/70 list-disc">Permanent freeze executed ~10 hours after LEA submission</li>
                <li class="text-[12px] text-white/70 list-disc">Full freeze applied in accordance with LEA directive — all transactional activity suspended</li>
              </ul>
            }
            @if (stepFourNext) {
              <ul class="flex flex-col pl-5 gap-3">
                <li class="text-[12px] text-[#80969A]/70 list-disc">Indicative Freeze Duration: ~3 months</li>
                <li class="text-[12px] text-[#80969A]/70 list-disc">Full account freeze implementation based on law enforcement request — all outgoing transactions restricted.</li>
              </ul>
            }
          </div>
        </div>
        <div class="flex gap-2">
          @let stepFiveCurrent = transaction.nextIncidentProgressStep === 'RECOVERY_OF_FUNDS';
          @let stepFiveSuccess = ['CASE_CLOSED'].includes(transaction.nextIncidentProgressStep);
          @let stepFiveNext = ['CASE_REPORTED', 'TEMPORARY_FREEZE', 'AWAITING_LEA_SUBMISSION', 'PERMANENT_FREEZE'].includes(transaction.nextIncidentProgressStep);
          <div class="flex relative">
            @if (stepFiveCurrent) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-current"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepFiveSuccess) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-success"></mat-icon>
              <span class="incident-line-success"></span>
            }
            @if (stepFiveNext) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-next"></mat-icon>
              <span class="incident-line-next"></span>
            }
          </div>
          <div class="flex flex-col w-full pb-[34px]">
            <div class="flex items-center justify-between gap-2 mb-3">
              <h4 class="font-bold text-[14px] leading-[1.2] text-white"
                [ngClass]="{
                  'text-[24px] -mt-2': stepFiveCurrent
                }"
                >Recovery & Repatriation of Funds</h4>

              @if (stepFiveSuccess) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">{{ transaction.incidentProgressMap.RECOVERY_OF_FUNDS.createdAt | date: 'dd.MM.yyyy | HH:mm' }}</span>
              }
              @if (stepFiveNext) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">~ 3 months</span>
              }
            </div>
            @if (stepFiveNext) {
              <ul class="flex flex-col pl-5 gap-3">
                <li class="text-[12px] text-white/70 list-disc" [ngClass]="{'!text-[#80969A]/70': stepSixNext}">Process to be initiated once legal clearance and asset verification are completed</li>
                <li class="text-[12px] text-white/70 list-disc" [ngClass]="{'!text-[#80969A]/70': stepSixNext}">Subject to case-specific LEA instructions and internal AML review</li>
              </ul>
            }
            @if (stepFiveSuccess || stepFiveCurrent) {
              <ul class="flex flex-col gap-3">
                <li class="text-[12px] text-white/70"><span class="text-[#FB0]">✓</span> All required documentation has been submitted to the competent law enforcement authorities</li>
                <li class="text-[12px] text-white/70"><span class="text-[#FB0]">✓</span> LEA has acknowledged the case and confirmed initiation of formal proceedings</li>
                <li class="text-[12px] text-white/70"><span class="text-[#FB0]">✓</span> Permanent asset freeze remains active and legally binding</li>
                <li class="text-[12px] text-white/70"><span class="text-[#FB0]">✓</span> Victim fund repatriation successfully completed and documented</li>
                <li class="text-[12px] text-white/70"><span class="text-[#FB0]">✓</span> Internal case file marked as procedurally closed — compliance records and audit logs secured</li>
              </ul>
              @if (stepFiveCurrent) {
                <div class="flex flex-col mt-3">
                  <span class="text-[12px] text-white/70 mb-1">Permanent Freeze Expires in:</span>
                  <app-lea-timer [time]="transaction.incidentProgressMap?.PERMANENT_FREEZE?.expiresIn ?? 0"></app-lea-timer>
                  <span class="text-[12px] text-white/70 mb-1 mt-3">Status: Completed (Pending Legal Resolution)</span>
                </div>
              }
            }
          </div>
        </div>
        <div class="flex gap-2">
          @let stepSixCurrent = false;
          @let stepSixSuccess = transaction.nextIncidentProgressStep === 'CASE_CLOSED';
          @let stepSixNext = ['CASE_REPORTED', 'TEMPORARY_FREEZE', 'AWAITING_LEA_SUBMISSION', 'PERMANENT_FREEZE', 'RECOVERY_OF_FUNDS'].includes(transaction.nextIncidentProgressStep);
          <div class="flex relative">
            @if (stepSixCurrent) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-current"></mat-icon>
            }
            @if (stepSixSuccess) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-success"></mat-icon>
            }
            @if (stepSixNext) {
              <mat-icon class="!w-[18px] !h-[18px]" svgIcon="incident-progress-next"></mat-icon>
            }
          </div>
          <div class="flex flex-col w-full">
            <div class="flex items-center justify-between mb-3">
              <h4 class="font-bold text-[14px] leading-[1.2] text-white"
                [ngClass]="{
                  'text-[24px] -mt-2': stepSixCurrent
                }"
                >Case Closed</h4>
              @if (stepSixSuccess) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">{{ transaction.incidentProgressMap.CASE_CLOSED.createdAt | date: 'dd.MM.yyyy | HH:mm' }}</span>
              }
              @if (stepSixNext) {
                <span class="text-white/50 text-[14px] whitespace-nowrap">~ 3-7 months</span>
              }
            </div>
            <ul class="flex flex-col pl-5 gap-3">
              <li class="text-[12px] text-white/70 list-disc" [ngClass]="{'!text-[#80969A]/70': stepSixNext}">Case finalized with all objectives met</li>
              <li class="text-[12px] text-white/70 list-disc" [ngClass]="{'!text-[#80969A]/70': stepSixNext}">Comprehensive audit confirmed full compliance and asset security</li>
              <li class="text-[12px] text-white/70 list-disc" [ngClass]="{'!text-[#80969A]/70': stepSixNext}">Official closure documented</li>
            </ul>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  </div>
  @if (transaction.nextIncidentProgressStep === 'TEMPORARY_FREEZE' && isComplianceRole()) {
    <div class="bg-button-report-gradient px-[18px] -mx-[18px] pb-5 pt-[26px] fixed w-[385px] bottom-0 right-[33px]">
      <div class="mt-[24px] flex flex-col bg-[#1B4249] rounded-[8px] p-2">
        <div class="flex items-center justify-center mb-[5px]">
          <span class="block w-[12px] h-[12px] rounded-full bg-[#C93535] mr-[5px]"></span>
          <span class="text-[12px] text-white leading-[1.4] uppercase font-medium">Action Required</span>
        </div>
        <button [disabled]="form.controls['temporaryDate'].invalid || form.controls['temporaryTime'].invalid || isLoading()" (click)="beforeSubmitTemporaryBlock()" type="button" class="flex items-center justify-center rounded-[4px] bg-white min-h-[54px] disabled:opacity-30">
          <mat-icon class="!w-[16px] !h-[16px]" svgIcon="lea-report-closed"></mat-icon>
          <span class="text-[16px] font-medium leading-[1.4] text-[#022D35]">Temporary Asset Freeze</span>
        </button>
      </div>
    </div>
  }
  @if (transaction.nextIncidentProgressStep === 'AWAITING_LEA_SUBMISSION' && userRole() === 'POLICE') {
    <div class="bg-button-report-gradient px-[18px] -mx-[18px] pb-5 pt-[26px] fixed w-[385px] bottom-0 right-[33px]">
      <div class="mt-[24px] flex flex-col bg-[#1B4249] rounded-[8px] p-2">
        <div class="flex items-center justify-center mb-[5px]">
          <span class="block w-[12px] h-[12px] rounded-full bg-[#C93535] mr-[5px]"></span>
          <span class="text-[12px] text-white leading-[1.4] uppercase font-medium">Action Required</span>
        </div>
        <div class="flex flex-col min-h-[54px] border border-solid border-white rounded-[4px] py-[6px] mb-1 px-2">
          <label class="text-[12px] text-white/70 leading-[1.2] mb-[5px]">Comment:</label>
          <input appNormalizeSpaces [formControl]="comment" class="text-[14px] text-white leading-[1] bg-transparent outline-none" type="text" placeholder="Enter comment">
        </div>
        <button (click)="beforeSubmitLeaRequestSubmission()" [disabled]="comment.invalid || isLoading()" type="button" class="flex items-center justify-center rounded-[4px] bg-white min-h-[54px] disabled:opacity-30">
          <mat-icon class="!w-[16px] !h-[16px]" svgIcon="lea-report-permantn-closed"></mat-icon>
          <span class="text-[16px] font-medium leading-[1.4] text-[#022D35]">Confirm LER Request</span>
        </button>
      </div>
    </div>
  }
  @if (transaction.nextIncidentProgressStep === 'PERMANENT_FREEZE' && isComplianceRole()) {
    <div class="bg-button-report-gradient px-[18px] -mx-[18px] pb-5 pt-[26px] fixed w-[385px] bottom-0 right-[33px]">
      <div class="mt-[24px] flex flex-col bg-[#1B4249] rounded-[8px] p-2">
        <div class="flex items-center justify-center mb-[5px]">
          <span class="block w-[12px] h-[12px] rounded-full bg-[#C93535] mr-[5px]"></span>
          <span class="text-[12px] text-white leading-[1.4] uppercase font-medium">Action Required</span>
        </div>
        <button [disabled]="form.controls['permanentDate'].invalid || form.controls['permanentTime'].invalid || isLoading()" (click)="beforeSubmitPermanentBlock()" type="button" class="flex items-center justify-center rounded-[4px] bg-white min-h-[54px] disabled:opacity-30">
          <mat-icon class="!w-[16px] !h-[16px]" svgIcon="lea-report-permantn-closed"></mat-icon>
          <span class="text-[16px] font-medium leading-[1.4] text-[#022D35]">Confirm Permanent Freeze</span>
        </button>
      </div>
    </div>
  }
}
